import { combineReducers } from 'redux'
import { fetchData } from '../../api' //dispatchAPIFetch


// Fetch Single 
const FETCH_PAGE_REQUEST = 'pages/FETCH_PAGE_REQUEST'
const FETCH_PAGE_SUCCESS = 'pages/FETCH_PAGE_SUCCESS'
const FETCH_PAGE_FAILURE = 'pages/FETCH_PAGE_FAILURE'
const FETCH_PAGE_CACHED= 'pages/FETCH_PAGE_CACHED'

const pages = (state = [], action) => {

    let data = [];

    switch (action.type) {

        case FETCH_PAGE_SUCCESS:
            return Object.assign([], state, [action.response])

        default: 
            return state
    }  
}


const reducer = combineReducers({
    pages
})



export const fetchPage = (slug: String) => (dispatch) => {
    
    dispatchAPIFetch(
        dispatch,
        `wpapi/pages/${slug}`,
        FETCH_PAGE_REQUEST,
        FETCH_PAGE_SUCCESS,
        FETCH_PAGE_FAILURE
    )      
}

function dispatchAPIFetch(dispatch, endpoint, request_type, success_type, failure_type) { //

    dispatch({type: request_type }) 

    return fetchData(endpoint)
        .then(response => {
            // console.log('endpoint',endpoint);
            // console.log('page response',response);
            dispatch({
                type: success_type,
                response
            })
        })
        .catch(error => {
            if(error){
                dispatch({
                    type: failure_type,
                    error
                })
            }
        }); 
}


export const getPages = state => state.pages.pages

export default reducer



// WEBPACK FOOTER //
// ./client/modules/Page/redux.js